import { api } from "./api";

const SS_KEY = "mm_invite_token";

export function readInviteFromUrl() {
  try {
    const u = new URL(window.location.href);
    return u.searchParams.get("invite");
  } catch { return null; }
}

export function persistInviteToken(token) {
  if (!token) return;
  sessionStorage.setItem(SS_KEY, token);
}

export function popPendingInvite() {
  const t = sessionStorage.getItem(SS_KEY);
  if (t) sessionStorage.removeItem(SS_KEY);
  return t;
}

/** If an invite token is present in URL or sessionStorage, attempt to accept it.
 *  Returns the accept response (or null if no invite / failure). Caller must be
 *  authenticated (api interceptor injects Bearer token automatically). */
export async function acceptPendingInvite() {
  const token = readInviteFromUrl() || popPendingInvite();
  if (!token) return null;
  try {
    const r = await api.post("/invitations/accept", { token });
    return r.data;
  } catch (e) {
    // Bubble up message for the caller to toast
    const detail = e?.response?.data?.detail || "Invitation could not be accepted";
    const err = new Error(detail);
    err.detail = detail;
    throw err;
  }
}
